export const types = {
  "[Login]": "User logged In",
  "[Reselect]": "User rehydration",
  "[Logout]": "Logout User",
};
